import { ColorSpaceTypes } from '@tokens-studio/types'

export const getModifyColorSpaces = (): ColorSpaceTypes[] => {
  return [ColorSpaceTypes.LCH, ColorSpaceTypes.SRGB, ColorSpaceTypes.P3, ColorSpaceTypes.HSL]
}
